export interface WarpWeftPlanRepeat {
  startColumn: number;
  endColumn: number;
  repeat: number;
  level: number;
}
